import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { PageBannerContainer } from 'components/PageBannerContainer/PageBannerContainer';
import { OrganizationType } from 'generated/graphql';
import { selectOrganization, selectUser } from 'entities/user/selectors';
import { Privileges } from 'utils/privileges';
import { NonprofitEntityType } from 'entities/organization/model';
import AffiliationPageBanner from 'assets/pageBanners/affiliations.avif';

import ChapterRequestModal from './ChapterRequestModal';
import Tabs from './Tabs';
import AcceptedChapters from './AcceptedChapters';
import PendingChapterRequests from './PendingChapterRequests';
import RejectedChapterRequests from './RejectedChapterRequests';

const ChaptersPage = () => {
  const user = useSelector(selectUser);
  const organization = useSelector(selectOrganization);

  const isNonprofitOrganizer = organization.type === OrganizationType.Nonprofit;

  const isGovEntityOrMembershipOrg =
    organization.nonprofitEntityType === NonprofitEntityType.governmentEntity ||
    organization.nonprofitEntityType === NonprofitEntityType.memberAssociatedEntity;

  const canAddChapterRequests =
    organization.nonprofitEntityType === NonprofitEntityType.nonprofit &&
    !organization.parent &&
    user.hasPrivilege(Privileges.CHAPTERS_MANAGE);

  const history = useHistory();

  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);

  const { type } = useParams();

  if (!user || !organization) {
    return null;
  }

  if (!isNonprofitOrganizer || isGovEntityOrMembershipOrg) {
    history.replace('/');
  }

  let content;

  if (type === 'accepted') {
    content = <AcceptedChapters openNewChapterModal={setOpen} />;
  }

  if (type === 'pending') {
    content = <PendingChapterRequests openNewChapterModal={setOpen} newChapterModalOpen={open} />;
  }

  if (type === 'rejected') {
    content = <RejectedChapterRequests />;
  }

  return (
    <>
      <Helmet title="Chapters" />
      <PageBannerContainer color="#FFF9E2" backgroundImage={AffiliationPageBanner}>
        <h1>Chapters</h1>
        <div style={{ marginLeft: 'auto' }}>
          {canAddChapterRequests && (
            <Button color="primary" variant="outlined" size="large" onClick={() => setOpen(true)}>
              Add a Chapter
            </Button>
          )}
        </div>
      </PageBannerContainer>

      <div style={{ marginTop: 32 }}>
        If your organization has local chapters you will find them here.
      </div>

      <Tabs />

      {content}

      {open && <ChapterRequestModal modalOpen={open} onClose={onClose} />}
    </>
  );
};

export default ChaptersPage;
